import { TextField } from "@material-ui/core";
import { SourceType, AdminSourceResponse } from "@authory-packages/core";
import { FieldSetStyles } from "../../styles";
import { ChangeEvent } from "react";
import { showRssSourceUrlField } from "./utils";

export type SourceSpecificConfigProps = {
  source: AdminSourceResponse;
  rssSourceUrl?: string;
  sitemapSourceUrl?: string;
  onInputChangeHandler: (e: ChangeEvent) => void;
  onInputBlurHandler: (e: ChangeEvent) => void;
};

export const SourceSpecificConfig = ({
  source,
  rssSourceUrl,
  sitemapSourceUrl,
  onInputChangeHandler,
  onInputBlurHandler,
}: SourceSpecificConfigProps) => {
  const fieldSetStyles = FieldSetStyles();

  return (
    <fieldset className={fieldSetStyles.container}>
      <legend>Source Specific Settings:</legend>
      {showRssSourceUrlField.includes(source.type) && (
        <TextField
          fullWidth
          label="Real url"
          name="configuration.rssSourceUrl"
          size="small"
          value={rssSourceUrl}
          onChange={onInputChangeHandler}
          onBlur={onInputBlurHandler}
          variant="outlined"
        />
      )}
      {source.type === SourceType.Sitemap && (
        <TextField
          fullWidth
          label="Source url"
          name="configuration.sitemapSourceUrl"
          size="small"
          value={sitemapSourceUrl}
          onChange={onInputChangeHandler}
          onBlur={onInputBlurHandler}
          variant="outlined"
        />
      )}
    </fieldset>
  );
};
